import {useUserState} from '../context'
import { Redirect } from 'react-router'
import { Menu } from '../components/Menu'

export const MainPage = (props) => {
    const {logined} = useUserState()

    if( logined === false ){
        return (
            <Redirect to={ {pathname:"/login"} } />
        )
    }
    return (
        <div className="mainPage">
             <Menu />
             <div className="contents">
                 
             </div>
        </div>
    )
}